<template>
  <div class="room-type">
        <div class="d-flex justify-content-between">
            <div class="room-title">
                {{discount?'优惠房':'用房需求'}}
                <span v-if="discount">(可以设置优惠房减免总金额)</span> 
            </div>
            <el-button class="mr-3" icon="el-icon-plus" type="primary" size="mini" @click="submitPost()">新增日期</el-button>
        </div>
        <div class="room-rnk mt-3" ref="scrollRoom" v-if="room_need.length>0">
            <!--房型标题-->
            <ul class="roomtypetitle" >
                <li :style="{width:modify?'20%':'30%'}" class="mr-2">入住日期</li>
                <li class="roomtypetitle-information" :class="{'w-80':modify}">
                    <div v-for="(item,index) in modify?modifyroomtypetitle:roomtypetitle" :key="index" :style="{width:item.width}">
                        
                        {{discount&&item.name=='单价'?'优惠单价':item.name}}
                    </div>
                </li>
            </ul>
            <div>
                <div class="roomtypetitle mt-3 roomtypetitle-bottom" v-for="(data,i) in room_need" :key="data.value">
                    <!--入住日期-->
                    <div :style="{width:modify?'20%':'30%'}" class="mr-2" >
                        <el-date-picker 
                        v-model="data.date"
                        type="date" 
                        value-format="timestamp"
                        :picker-options="forbiddenStartTime"
                        @input="onFieldChange"
                        :class="{ roomRed: isFieldError(i, null, 'date') }"
                        placeholder="选择日期"/>
                    </div>
                    <div class="roomtypetitle-list" :class="{'w-80':modify}">
                        <!--房间类型、间数、操作-->
                        <div v-for="(item,index) in data.offer_info"  :key="index" class="d-flex w-100" :class="{'mt-2':index>0}">
                            <!--房间类型-->
                            <el-select  
                                v-model="item.type" 
                                placeholder="请选择类型" 
                                @input="onFieldChange"
                                class="w-50"  
                                :class="{ roomRed: isFieldError(i, index, 'type') }">
                                <el-option
                                v-for=" i in $GVAR.roomStyle"
                                :key="i.id"
                                :label="i.name"
                                :value="i.id">
                                </el-option>
                            </el-select>
                            <!--房间类型-->
                            <el-select 
                                v-model="item.offer_title"
                                :class="{ roomRed: isFieldError(i, index, 'offer_title') }"
                                @change="getId($event,i,index)"
                                @blur="blurs($event,i,index)"
                                 filterable
                                allow-create
                                default-first-option
                                placeholder="选择或输入房型"
                            class="w-50 ml-2"  v-if="modify">
                            <template>
                                <el-option
                                    v-for="roomItem in StoreRoomList"
                                    :key="roomItem.title"
                                    :label="roomItem.title"
                                    :value="`${roomItem.id},${roomItem.title}`"
                                >
                                </el-option>
                             </template>
                            </el-select>
                            <!--早餐-->
                            <el-select 
                                v-model="item.breakfast"
                                :class="{ roomRed: isFieldError(i, index, 'breakfast') }"
                                @change="changeBreakfastType($event,i,index)"
                                @blur="blurBreakfastType($event,i,index)"
                                filterable
                                allow-create
                                default-first-option
                                placeholder="选择或输入早餐"
                            class="w-50 ml-2"  v-if="modify">
                            <template >
                                <el-option
                                     v-for="roomItem in $GVAR.breakfastTypeArr"
                                    :key="roomItem.name"
                                    :label="roomItem.name"
                                    :value="`${roomItem.id},${roomItem.name}`"
                                >
                                </el-option>
                             </template>
                            </el-select>
                            <!--间数-->
                            <el-input 
                                type="number"  
                                v-model.number="item.room_num" 
                                @mousewheel.native.prevent
                                @input="onFieldChange" 
                                class="ml-2 w-40" 
                                :class="{ roomRed: isFieldError(i, index, 'room_num') }"
                                placeholder="间数">
                                <span slot="append">间</span>
                            </el-input>
                            <!--单价-->
                            <el-input 
                            placeholder="金额"
                            v-model.number="item.offer_price"  
                            class=" ml-2 w-40"
                            @input="onFieldChange"
                            :class="{ roomRed: isFieldError(i, index, 'offer_price') }"
                            type="number" v-if="modify">
                                <!-- <span slot="prepend">&yen;</span> -->
                                <span slot="append" class="lisxn">元/晚</span>
                            </el-input>
                            <!--操作-->
                            <div class="w-30 deletes">
                                <el-tooltip class="item" effect="dark" content="新增类型" placement="top">
                                    <i class="el-icon-circle-plus text-primary"  @click="addMeeting(i)" v-if="index==0"></i>
                                </el-tooltip>
                                <i class="el-icon-delete" @click="splicse(i,index)" ></i>
                                <!-- <el-button  class="mt-1" type="danger" size="mini" @click="splicse(i,index)">删除</el-button> -->
                            </div>
                        </div>
                        <!-- <div class="d-flex   mt-3">
                            <el-button class="mr-3" icon="el-icon-plus" type="primary" size="mini" @click="addMeeting(i)">新增类型</el-button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { mapState} from 'vuex'
export default {
  name: '',
  components: {},
  props: {
    room_need_clone: {
      type: Array,
      default: () => []
    },
    //是否是修改订单
    modify: {
      type: Boolean,
      default: false
    },
    //是否是优惠房
    discount: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
        room_need:[],
        meetObjfs:{
            date:'',
            offer_info:[
                { type:'',room_num:'',offer_price:'',offer_id:'',offer_title:'',breakfast:''},
            ],
            date:'',
            offer_info:[
                { type:'',room_num:'',offer_price:'',offer_id:'',offer_title:'',breakfast:''},
            ]
        },
        roomtypetitle:[
            {name:'类型',width:'50%'},
            {name:'间数',width:'50%'},
            {name:'操作',width:'30%'},
        ],
        modifyroomtypetitle:[
            {name:'类型',width:'50%'},
            {name:'房型',width:'50%'},
            {name:'早餐',width:'50%'},
            {name:'间数',width:'40%'},
            {name:'单价',width:'40%'},
            {name:'操作',width:'30%'},
        ],
        // 错误标记：精准记录 行+子项+字段名
        errorMap: {},
        isSubmit: false
    };
  },
  computed: {
    ...mapState(['StoreRoomList']),
  },
  watch: {
    room_need_clone: {
        handler(newVal) {
            this.room_need = [...newVal];
        },
        deep: true, // 开启深度监听
        immediate: true // 一进页面就执行一次
    }
  },
  created() {},
  mounted() {},
  methods: {
    //新增一个日期
    submitPost(){
        let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs)));
        this.room_need.push(data);
        this.scrollToBottom();
    },
    //添加新的房型
    addMeeting(i){
        let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs.offer_info[0])));
        this.room_need[i].offer_info.push(data);
    },
    //删除房型
    splicse(i,index){
        if( this.room_need[i].offer_info.length==1){
            this.room_need.splice(i,1)
        }else{
            this.room_need[i].offer_info.splice(index,1)
        }
    },
    // 滚动到底部
    scrollToBottom() {
        // 等到 DOM 更新完毕再滚动
        this.$nextTick(() => {
        const el = this.$refs.scrollRoom;
        console.log(el);
        if (el) {
            // 平滑滚动到底部
            el.scrollTop = el.scrollHeight;
        }   
        });
    },
    //确认订单
    submitForm(e){
        this.isSubmit = true;
        const valid = this.validateAll();
        console.log(valid,'类型')
        if (!valid) {
            this.$message.error('请填写完整的房间需求信息');
        return false;
        }
        return {room_need:this.room_need};
    },
    // 全局校验，逐个字段判断
    validateAll() {
        this.errorMap = {};
        let pass = true;
        this.room_need.forEach((row, rowIdx) => {
        // 校验 date
        if (!row.date) {
            this.setFieldError(rowIdx, null, 'date');
            pass = false;
        }

        // 遍历 offer_info 每一项、每一个字段
        row.offer_info.forEach((item, offerIdx) => {
            const fields = this.modify?['type', 'room_num','offer_price', 'offer_title','breakfast']:['type', 'room_num',] 
            fields.forEach(field => {
            // 去除首尾空格判断空值
            if (!item[field] || String(item[field]).trim() === '') {
                this.setFieldError(rowIdx, offerIdx, field);
                pass = false;
            }
            });
        });
        });
        return pass;
    },
    // 记录错误字段：key 格式 row-idx|offer-idx|field
    setFieldError(rowIdx, offerIdx, field) {
        const key = offerIdx === null 
        ? `${rowIdx}|date` 
        : `${rowIdx}|${offerIdx}|${field}`;
        this.errorMap[key] = true;
    },
    // 输入时实时更新错误状态
    onFieldChange() {
        if (!this.isSubmit) return;
        this.validateAll();
    },

    // 判断单个字段是否标红
    isFieldError(rowIdx, offerIdx, field) {
        if (!this.isSubmit) return false;
        const key = offerIdx === null 
        ? `${rowIdx}|date` 
        : `${rowIdx}|${offerIdx}|${field}`;
        return !!this.errorMap[key];
    },
    forbiddenStartTime(item,index) {
        return {
          // 在禁用日期的回调中使用index
          disabledDate: (date) => {
            let meetObj=[...this.room_need]
            //删除当前对象组
            meetObj.splice(index, 1);
            //判断是否有重复时间-重复布局 
            const allIndexes = meetObj.reduce((acc, user, index) => {
              if (user.type === item.type&&user.timeslot === item.timeslot) {
                acc.push(meetObj[index]); // 符合条件则添加索引到数组
              }
              return acc;
            }, []); // 初始值为空数组
            //判断禁用值
            let  hasTarget = allIndexes.some(user => user.date === date.getTime());
            console.log(hasTarget);
            return hasTarget
          }
        }
    },
    // 房型相关
    getId(val,i,index){
        let [id, name] = val.split(',');
        let room_offer={...this.room_need[i].offer_info[index],offer_id:id?id:'0',offer_title:name?name:id}
        this.$set(this.room_need[i].offer_info,index,room_offer);
        console.log(this.room_need,5789);
    },
    blurs(val,i,index){
        if(val.target.value){
            let room_offer={...this.room_need[i].offer_info[index],offer_id:'0',offer_title:val.target.value}
            this.$set(this.room_need[i].offer_info,index,room_offer);
        }
        console.log(this.room_need,78910);
    },
        //早餐类型
    changeBreakfastType(val,i,index){
        let [id, name] = val.split(',');
        let room_offer={...this.room_need[i].offer_info[index],breakfast:name}
        this.$set(this.room_need[i].offer_info,index,room_offer);
    },
    blurBreakfastType(val,i,index){
        if(val.target.value){
        let room_offer={...this.room_need[i].offer_info[index],breakfast:val.target.value}
        this.$set(this.room_need[i].offer_info,index,room_offer);
        }
    }
  }
};
</script>

<style lang="scss" scoped>
    .room-type{
        text-align: left;
    }
    .room-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-left: 12px;
        &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 4px;
            height: 20px;
            width: 4px;
            background-color: var(--smtc-color-primary);
            border-radius: 50px;
        }
    }
    .roomtypetitle{
        display: flex;
        width: 100%;
        >li{
            text-align: center;
        }
    }
    .roomtypetitle-information{
        width: 70%;
        display: flex;
        text-align: center;
    }
    .roomtypetitle-list{
        width: 70%;
        display: flex;
        text-align: center;
        flex-wrap: wrap;
    
    }
    .roomtypetitle-bottom{
        border-bottom: 1px #eee solid;
        padding-bottom: 14px;
    }
    .room-type-footer{
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
    .deletes{
        text-align: center;
        display: flex;
        justify-content: center;
        color: red;
        font-size: 16px;
        margin-top: 10px;
        cursor: pointer;
        i:nth-child(1){
            margin-right: 5px;
        }
    }
    .room-rnk{
        max-height: 600px;
        overflow-y: auto;
        scroll-behavior: smooth; 
    }
    .room-title span{
        font-size: 14px;
        font-weight: normal;
    }
</style>
<style>
    .room-type .el-date-editor.el-input{
        width: 100%;
    }
    .room-type .el-input__inner{
        text-align: center;
    }
    .room-type .el-input-group__append,.room-type .el-input--suffix .el-input__inner ,.room-type .meeting-type .el-input__inner{
        font-size: 12px;
    }
    .roomRed .el-input__inner,
    .roomRed .el-date-editor .el-input__inner {
    border-color: #F56C6C !important;
    }
</style>